import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import DefaultButton from '../../../global/default-button/default-button';
import { DefaultSpinner } from '../../../global/spinner/default-spinner';
import { MeetingFormFields } from '../shared/meeting-form-fields/meeting-form-fields';
import { FormField } from '../../../global/form/form-field/form-field';
import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { connectZoomVM } from '../../zoom.context';
import { ResourcesNavigation } from '../../../_events/_manage-event/shared/navigation/navigation';
import { UpdateMeetingViewModel } from './update-meeting.viewmodel';

const UpdateMeetingPresentation = injectIntl(mobxReact.observer((props: {vm: UpdateMeetingViewModel; intl: IntlShape }) => {
    const { vm } = props;
    const formFields = vm.getFormFields();

    return (
        <div>
            <section className='resources-tabs horizontal-row scheduled-meetings-list__horizontal-row'>
                <ResourcesNavigation />
            </section>
            <div className='meeting-form page-size-form-container'>
                <form className='oe-form'>
                    <div className='oe-form__header'>
                        <h2 className='oe-form__title'>
                            <FormattedMessage
                                id='oe.zoom.updateMeeting'
                                defaultMessage='Update Zoom Meeting'
                                description='Label text'
                            />
                        </h2>
                    </div>

                    <FormField label={
                        <FormattedMessage
                            id='oe.meeting.Id'
                            defaultMessage='Meeting ID'
                            description='Label text'
                        />
                    }>
                        <span>{vm.getZoomMeetingId()}</span>
                    </FormField>

                    <MeetingFormFields vm={formFields} />

                    <div className='oe-form__footer'>
                        <DefaultButton
                            modifier='fat'
                            text={
                                <FormattedMessage
                                    id='oe.zoom.updateMeeting'
                                    defaultMessage='Update Zoom Meeting'
                                    description='Label text'
                                />
                            }
                            onClick={vm.submitForm}
                        />
                    </div>

                    </form>
                <DefaultSpinner visible={vm.getIsLoading()}/>
            </div>
        </div>
    );
}));

interface IContainerProps {
    meetingId: number;
}

const UpdateMeetingContainer = withViewModel(
    UpdateMeetingPresentation,
    (props: { meetingId: number }) => {
        const scheduleMeetingVM = new UpdateMeetingViewModel(props.meetingId);
        scheduleMeetingVM.fetchMeetingDetails();
        return scheduleMeetingVM;
    },
    props => [props.meetingId]
);

const UpdateMeeting = connectZoomVM<IContainerProps>(UpdateMeetingContainer, zoomVM => {
   return {
        meetingId: zoomVM.getMeetingId()
   };
});

export { UpdateMeeting };